import React, { useEffect, useState } from 'react'
import {
  fetchActiveActions,
  createActiveAction,
  updateActiveAction,
  deleteActiveAction
} from 'helpers/backend_helper'
import { Container } from 'reactstrap'
import BreadCrumb from 'Components/Common/BreadCrumb'
import { toast } from 'react-toastify'
import ServicesTable from './ServicesTable'
import ServiceModal from './ServiceModal'

export interface IService {
  _id?: string
  name: string
  label: string
  description: string
  price: number
  isActive: boolean
  sortOrder?: number
  /** Baski sayfasindaki karekodun adresi (bos = karekod basilmaz). */
  printQrUrl?: string
}

const Services = () => {
  document.title = 'Services | SocialBooth - Admin Dashboard'

  const [fetching, setFetching] = useState<boolean>(false)
  const [serviceRecords, setServiceRecords] = useState<IService[]>([])
  const [openServicePopup, setOpenServicePopup] = useState<boolean>(false)
  const [currentService, setCurrentService] = useState<IService>()
  const [editMode, setEditMode] = useState<boolean>(false)
  const [canEdit, setCanEdit] = useState<boolean>(true)

  const fetchServiceRecords = async () => {
    try {
      setFetching(true)
      const response = await fetchActiveActions()
      setServiceRecords(response.data || [])
    } catch (e) {
      const errMsg = e as string
      toast.error(errMsg)
    }
    setFetching(false)
  }

  useEffect(() => {
    fetchServiceRecords()
  }, [])

  const handleOpenDetails = (id: string) => {
    const selected = serviceRecords.find((s) => s._id === id)
    if (selected) {
      setCurrentService(selected)
      setOpenServicePopup(true)
    }
  }

  const handleCreateOrUpdateService = async (params: any) => {
    try {
      const res = editMode
        ? updateActiveAction(params, params._id)
        : createActiveAction(params)
      const response = await res
      const data = response.data

      if (response.message === 'SUCCESSFULL') {
        if (editMode) {
          setServiceRecords(
            serviceRecords.map((s: IService) =>
              s._id === data._id ? data : s
            )
          )
        } else {
          setServiceRecords([data, ...serviceRecords])
        }
        return response.message
      }

      return response.data
    } catch (e) {
      const errMsg = e as string
      toast.error(errMsg)
      return 'FALSE'
    }
  }

  const handleDeleteService = async (id: string) => {
    try {
      const response = await deleteActiveAction(id)

      if (response.message === 'SUCCESSFULL') {
        setServiceRecords(serviceRecords.filter((s) => s._id !== id))
      }

      return response.message
    } catch (e) {
      const errMsg = e as string
      toast.error(errMsg)
      return 'FALSE'
    }
  }

  const handleReorder = async (id: string, direction: 'up' | 'down') => {
    const idx = serviceRecords.findIndex((s) => s._id === id)
    if (idx < 0) return
    const swapIdx = direction === 'up' ? idx - 1 : idx + 1
    if (swapIdx < 0 || swapIdx >= serviceRecords.length) return

    const current = serviceRecords[idx]
    const target = serviceRecords[swapIdx]

    const newOrder = [...serviceRecords]
    newOrder[idx] = target
    newOrder[swapIdx] = current
    setServiceRecords(newOrder)

    // Persist sortOrder to backend
    try {
      await updateActiveAction({ ...current, sortOrder: swapIdx }, current._id!)
      await updateActiveAction({ ...target, sortOrder: idx }, target._id!)
    } catch (e) {
      toast.error('Failed to update order')
      setServiceRecords(serviceRecords)
    }
  }

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <BreadCrumb title='Services' pageTitle='Services' />
          <ServicesTable
            serviceRecords={serviceRecords}
            setOpenServicePopup={setOpenServicePopup}
            handleOpenDetails={handleOpenDetails}
            setEditMode={setEditMode}
            handleDeleteService={handleDeleteService}
            fetching={fetching}
            setCanEdit={setCanEdit}
            onReorder={handleReorder}
          />
          <ServiceModal
            isOpen={openServicePopup}
            setOpenPopup={setOpenServicePopup}
            handleCreateOrUpdateService={handleCreateOrUpdateService}
            serviceRecord={currentService}
            editMode={editMode}
            canEdit={canEdit}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default Services
